export default [
  {
    path: '/fee-expiration-alerts',
    name: 'fee-expiration-alert',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-expiration-alert/index.vue')
  }
]
